import QuantityControl from './QuantityControl';
import { formatPrice } from '../utils/formatPrice';
import { resolveImageSrc } from '../utils/resolveImageSrc';

function ProductCard({ product, quantity, onAdd, onRemove }) {
  const imageSrc = resolveImageSrc(product.image);

  return (
    <div className="item">
      <div className="thumb" aria-hidden="true">
        {imageSrc ? (
          <img className="thumbImage" src={imageSrc} alt="" />
        ) : (
          <div className="thumbEmoji">{product.emoji}</div>
        )}
      </div>

      <div className="info">
        <div className="nameRow">
          <div className="name">{product.name}</div>
          {product.price > 0 ? (
            <div className="price">{formatPrice(product.price)}</div>
          ) : (
            <div className="price free">免费</div>
          )}
        </div>
        <div className="desc">{product.desc}</div>
        <div className="actions">
          {quantity > 0 ? (
            <QuantityControl
              value={quantity}
              onDecrease={onRemove}
              onIncrease={onAdd}
              decreaseLabel={`减少 ${product.name}`}
              increaseLabel={`增加 ${product.name}`}
            />
          ) : (
            <button className="addBtn" type="button" onClick={onAdd}>
              加入购物车
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
